export default {
  common_component: {
    // for date & time range
    // 高级搜索
    // 下拉选项的一些国际化
    // 筛选显示组件
    filters_display_widget: {
      // 一些基本的参数查询的key定义
      param_keys: {
        created_at: '创建时间',
        updated_at: '更新时间',
        keyword: '关键词'
      }
    },
    // 数值范围
    // 充电站选择
    lc_station_selector: {
      unlimit: '不限',
      specified: '指定充电站',
      sp: '运营商',
      search_station_name: '按站名查询（输入要查找的站）',
      search_sp: '按运营商查询',
      select_all: '全选',
      select_stations: '请选择电站',
      station_name: '站名',
      charger_unit: '个桩',
      station_unit: '个站'
    },
    // 集团选择
    lc_groups_selector: {
      name: '集团',
      status: '状态'
    },
    // 共享电站选择
    lc_ev_charging_stations_selector: {
      name: '电站',
      status: '状态',
      service_provider: '运营商'
    },
    lc_equipment_productions_selector: {
      equipment_nameplate_number: '桩铭牌号'
    },
    // 监控电站选择
    lc_charge_stations_selector: {
      name: '监控电站'
    },
    // 管理员选择
    lc_admins_selector: {
      name: '管理员',
      email: '邮箱',
      mobile: '手机号'
    },
    // 富文本
    lc_editor: {
      upload_fail: '上传失败'
    },
    // 费率选择弹窗
    lc_billing_rule_select_dialog: {
      select_billing_rule: '选择充电费率',
      service_provider: '运营商',
      billing_rule: '充电费率',
      no_billing_rule: '没有选择费率'
    },
    // 删除确认
    lc_delete_confirm_dialog: {
      delete_confirm_prefix: '确定要删除',
      delete_confirm_suffix: '记录吗？'
    },
    // 重复周期选择
    lc_recurrence_rule: {
      placeholder: {
        select_recurrence_rule: '请选择选择周期'
      },
      type_options: [
        { label: '每天', value: 'daily' },
        { label: '工作日', value: 'workday' },
        { label: '自定义', value: 'custom' }
      ],
      weeks: [
        { label: '周日', value: 0 },
        { label: '周一', value: 1 },
        { label: '周二', value: 2 },
        { label: '周三', value: 3 },
        { label: '周四', value: 4 },
        { label: '周五', value: 5 },
        { label: '周六', value: 6 }
      ]
    },
    // 费率选择
    lc_billing_rule_selector: {
      placeholder: {
        select_billing_rule: '请选择费率'
      }
    },
    coupon_card: {
      coupon_reward_count: '数量'
    },
    lc_coupon_definitions_selector: {
      name: '优惠券名',
      coupon: '优惠券',
      status: '状态'
    },
    lc_charging_package_definitions_selector: {
      name: '充电包名'
    }
  }
}
